import { Button } from 'antd';
import styles from './index.module.scss';

const EMPTY_IMG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/empty.png';
const SEARCH_EMPTY_IMG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/searchEmpty.png';

const MaterialEmpty = ({ isSearch, onUpload }) => {
    return (
        <div className={styles.MaterialEmpty}>
            <img src={isSearch ? SEARCH_EMPTY_IMG : EMPTY_IMG} alt={isSearch ? '没有与搜索条件匹配的图片' : '暂无参考图'} className={styles.emptyImg} />
            <p className={styles.text}>{isSearch ? '没有与搜索条件匹配的图片' : '暂无参考图'}</p>
            {
                !isSearch && (
                    <Button type="primary" className={styles.uploadBtn} onClick={onUpload}>
                        上传参考图
                    </Button>
                )
            }

        </div>
    );
};

export default MaterialEmpty;
